<template>
  <div class="details_box">
    <!-- 凍結資金詳情 -->
    <div class="deal_content_box" v-loading="inquireTF">
        <div class="deal_content_title">凍結資金詳情</div>
        <!-- 內容 -->
        <div class="deal_content">
          <!-- box -->
          <div class="content_box">
            <!-- 箭頭-box -->
            <p class="arrows_box">
              <span @click="detailsPN(previousId)"><i class="el-icon-caret-left"></i>上一筆</span>
              <span @click="detailsPN(nextId)">下一筆<i class="el-icon-caret-right"></i></span>
            </p>
            <!-- 箭頭-end -->
            <!-- 表單 -->
            <div class="table_box">
              <div>
                <p class="table_title">操作時間</p>
                <p class="table_content">{{this.$store.state.detailsList.starttime}}</p>
              </div>
              <div>
                <p class="table_title">業務流水單號</p>
                <p class="table_content">{{this.$store.state.detailsList.code}}</p>
              </div>
              <div>
                <p class="table_title">資金流水單號</p>
                <p class="table_content">{{this.$store.state.detailsList.capital_flow}}</p>
              </div>
              <div>
                <p class="table_title">業務類型</p>
                <p class="table_content">{{this.$store.state.detailsList.type}}</p>
              </div>
              <div>
                <p class="table_title">凍結金額</p>
                <p class="table_content">{{this.$store.state.detailsList.type == '解圈' ? '-' + this.$store.state.detailsList.frozen_money : this.$store.state.detailsList.frozen_money}}</p>
              </div>
              <div>
                <p class="table_title">圈存金額</p>
                <p class="table_content">{{this.$store.state.detailsList.type == '解圈' ? '-' + this.$store.state.detailsList.circle_money : this.$store.state.detailsList.circle_money}}</p>
              </div>
              <div>
                <p class="table_title">操作者</p>
                <p class="table_content">{{this.$store.state.detailsList.designation}}</p>
              </div>
              <div>
                <p class="table_title">操作備註</p>
                <p class="table_content">{{this.$store.state.detailsList.remark}}</p>
              </div>
            </div>
            <!-- 表單-end -->
            <!-- 按鈕-box -->
            <div class="button_box">
              <el-button type="primary" @click="detailsBack()">回上一頁</el-button>
            </div>
            <!-- 按鈕-end -->
          </div>
          <!-- box-end -->
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'OrderDetails',
  props: {
  },
  data() {
    return {
     inquireTF: false
    }
  },
  components: {
  },
  methods: {
    detailsBack(){
      this.$emit('detailsFun');
    },
    // FUN-上一筆/下一筆
    detailsPN(id){
      this.inquireTF = true;
      axios.get(this.$store.state.axiosFreezeDetailsUrl, {
          params: {
              id: id,
              uid: this.$store.state.uid
          }
      }).then((res) => {
          // console.log(res.data.message);
          this.inquireTF = false;
          this.$store.commit('changeDetails',res.data.message);
      })
    },
  },
  computed: {
    previousId(){
      return this.$store.state.detailsList.previous_page;
    },
    nextId(){
      return this.$store.state.detailsList.next_page;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 内容 */
    .datetime_box > span {
      margin: 10px;
    }
    .deal_content_box {
      font-size: 13px;
      margin-top: 20px;
    }
    .deal_content_title {
      height: 42px;
      background: #666666;
      line-height: 42px; 
      color: white;
      padding-left: 14px;
    }
    .deal_content {
      color: #000000;
      box-sizing: border-box;
      border: 1px solid #666666;
      background: #ffffff;
      padding: 50px 66px;
    }

  /* 表格 */
  .content_box {
    /* width: 600px; */
  }
  .arrows_box {
    display: flex;
    justify-content: space-between;
  }
  .arrows_box > span {
    cursor: pointer;
  }
  .table_box {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
  }
  .table_box > div {
    display: flex;
  }
  .table_box > div > p {
    border: 1px solid #e7e7e7;
    padding: 12px 0 12px 30px;
  }
  .table_box > div > p > span+span {
    margin-left: 55px;
  }
  .table_title {
    width: 180px;
  }
  .table_content {
    flex: 1;
  }
  .button_box {
    margin-top: 36px;
    display: flex;
    justify-content: flex-end;
  }
  .button_box .el-button {
    padding: 8px 20px;
  }
</style>
